import { Col, Row } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { ICart } from 'interface/cart.interface';
import { IProduct } from 'interface/product.interface';
import moment from 'moment';

interface IProps {
  cart?: ICart;
}

export default function CartInfo(props: IProps): JSX.Element {
  const { cart } = props;

  return (
    <>
      <div className="mb-4 flex flex-col gap-4 pb-20 border-b-2 border-[#E1E3E6]">
        <Content>
          <div className="text-xl font-bold mb-6">Thông tin giỏ hàng</div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Người tạo
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {cart?.user_created.fullName}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Email
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {cart?.user_created.email}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Khối phát hành
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {cart?.user_created.division}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Công ty phát hành
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {cart?.user_created.organization}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="text-base text-neutral-40 flex gap-2" span={4}>
              Đơn vị phát hành
            </Col>
            <Col className="text-base font-semibold" span={20}>
              : {cart?.user_created.departmentName}
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="text-base text-neutral-40 flex gap-2" span={4}>
              Cập nhập lần cuối
            </Col>
            <Col className="text-base font-semibold" span={20}>
              : {moment(cart?.updated_at).format('DD/MM/YYYY')}
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col
              span={24}
              className="text-base text-neutral-40 flex gap-2 mb-2"
            >
              Mô tả
            </Col>
            <Col className="text-base font-semibold" span={24}>
              {cart?.description}
            </Col>
          </Row>
        </Content>
      </div>
    </>
  );
}
